module.exports = __webpack_public_path__ + "static/media/iconTopPost.15119ee4.svg";